module.exports = __webpack_public_path__ + "static/img/menageService5.b3fd19f7.png";